import { atom } from 'recoil';

// authState의 타입 정의
interface AuthState {
  isAuthenticated: boolean;
  userType: string | null;
}

// 로컬 스토리지에서 auth 상태를 불러오는 함수
const getInitialAuthState = () => {
  const savedAuthState = localStorage.getItem('authState');
  if (savedAuthState) {
    return JSON.parse(savedAuthState);
  }
  return {
    isAuthenticated: false,
    userType: null,
  };
};

export const authState = atom<AuthState>({
  key: 'authState',
  default: getInitialAuthState(), // 초기 상태를 로컬 스토리지에서 가져옴
});
